import { FacilityFieldsFragment } from '@/graphql/__generated/sdk';

import { IUser, USA_CENTER_COORDINATES } from '@shared-components/constants';
import { Maybe } from '@shared-components/types';

export async function getPosition({
	officeInfo,
	defaultToCdn = false,
	user,
}: {
	defaultToCdn?: boolean;
	user?: Maybe<IUser>;
	officeInfo?: FacilityFieldsFragment | null;
}) {
	if (officeInfo?.location) {
		return {
			latitude: officeInfo?.location?.latitude as number,
			longitude: officeInfo?.location?.longitude as number,
		};
	}

	if (defaultToCdn) {
		return {
			latitude: (user?.coordinates?.latitude as number) || USA_CENTER_COORDINATES.latitude,
			longitude: (user?.coordinates?.longitude as number) || USA_CENTER_COORDINATES.longitude,
		};
	}

	if (globalThis.window === undefined) {
		return USA_CENTER_COORDINATES;
	}

	const fallbackCoords = user?.hasIpBasedCoordinates && user?.coordinates ? user.coordinates : USA_CENTER_COORDINATES;
	return getBrowserPosition(fallbackCoords);
}

export const getUsersPosition = (): Promise<GeolocationPosition> => {
	return new Promise((resolve, reject) => {
		globalThis.navigator?.geolocation.getCurrentPosition(resolve, reject);
	});
};

export async function getBrowserPosition(fallbackCoords: { latitude: number; longitude: number }) {
	if (!globalThis?.navigator?.geolocation) {
		return fallbackCoords;
	}
	try {
		const position = await getUsersPosition();
		return position.coords;
	} catch (error) {
		console.warn('Failed to get geolocation position:', error);
		return fallbackCoords;
	}
}
